export default {
	verify: {
		title: "Two-step verification",
		totpHint: "Enter the 6-digit code from your authenticator app.",
		emailHint: "We sent a 6-digit code to your email.",
		backupHint: "Enter one of your backup codes.",
		codeLabel: "Verification code",
		backupLabel: "Backup code",
		rememberDevice: "Remember this device for 30 days",
		submit: "Verify",
		invalidCode: "Invalid or expired code. Please try again.",
		resend: "Resend code",
		resending: "Resending...",
		resent: "Code resent to your email",
		resendError: "Could not resend the code",
		useBackup: "Use a backup code",
		useCodeInstead: "Use authenticator code",
		back: "Back to login",
	},
	settings: {
		title: "Two-step verification",
		description:
			"Add an extra layer of security to your account by requiring a code in addition to your password when signing in.",
		enabled: "Two-step verification enabled",
		disabled: "Two-step verification disabled",
		disabledHint: "Your account is protected by your password only.",
		methodLabel: "Method",
		backupRemaining: "{count} backup code(s) remaining",
		activate: "Enable",
		regenerate: "Regenerate backup codes",
		disable: "Disable",
	},
	methods: {
		totp: "Authenticator app",
		totpDesc: "Use Google Authenticator, Authy or similar (recommended).",
		email: "Email code",
		emailDesc: "Receive a code by email on each login.",
	},
	activate: {
		title: "Enable two-step verification",
		chooseMethod: "Choose how you want to receive verification codes.",
		continueBtn: "Continue",
		totpScan:
			"Scan the QR code with your authenticator app and enter the generated code.",
		totpManual: "Or enter this key manually:",
		qrAlt: "QR code for authenticator setup",
		emailSent: "We sent a verification code to your email.",
		confirm: "Enable",
	},
	backup: {
		title: "Backup codes",
		warning:
			"Store these codes in a safe place. Each code can be used once to sign in if you lose access to your primary method. They won't be shown again.",
		copy: "Copy",
		download: "Download",
		saved: "I've saved my codes",
		fileHeader: "Two-step verification backup codes — ORI",
	},
	disable: {
		title: "Disable two-step verification",
		description:
			"To confirm, enter a code from your verification method or a backup code.",
		codeLabel: "Verification or backup code",
	},
	regenerate: {
		title: "Regenerate backup codes",
		warning:
			"Generating new codes will invalidate your previous backup codes.",
		confirm: "Generate new codes",
	},
	devices: {
		title: "Trusted devices",
		empty: "No trusted devices",
		emptyHint:
			"Devices you remember during login appear here and won't ask for a code for 30 days.",
		unknownDevice: "Unknown device",
		lastUsed: "Last used",
		never: "Never",
		expires: "Expires",
		revoked: "Device revoked",
		revokeError: "Could not revoke the device",
	},
	reminder: {
		title: "Protect your account",
		text: "Turn on two-step verification for an extra layer of security when signing in.",
		activate: "Enable now",
		dismiss: "Dismiss",
	},
	messages: {
		statusError: "Could not load two-step verification status",
		setupError: "Could not start the setup",
		activated: "Two-step verification enabled successfully",
		invalidCode: "Invalid code. Please check and try again.",
		copied: "Copied to clipboard",
		copyError: "Could not copy",
		disabled: "Two-step verification disabled",
		regenerated: "New backup codes generated",
		regenerateError: "Could not regenerate backup codes",
	},
};
